"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../BaseComponent");
var $ = require("jquery");
var HegydCore_1 = require("../hegyd-core/HegydCore");
var eCommerce_1 = require("../../../utils/eCommerce");
var refreshHeaderShopName_1 = require("../../../utils/refreshHeaderShopName");
var ProductCardModal = /** @class */ (function (_super) {
    __extends(ProductCardModal, _super);
    function ProductCardModal($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        _this.modal = null;
        return _this;
    }
    ProductCardModal.prototype.bind = function () {
        this.initEvents();
        this.initPluginsModal();
    };
    ProductCardModal.prototype.getSelectorInputQuantity = function () {
        return "#add-cartModal input[name='product-count']";
    };
    ProductCardModal.prototype.getElementInputQuantity = function () {
        return $(this.getSelectorInputQuantity());
    };
    ProductCardModal.prototype.getSelectorUpQuantity = function () {
        return '#add-cartModal .btn-left';
    };
    ProductCardModal.prototype.getSelectorDownQuantity = function () {
        return '#add-cartModal .btn-right';
    };
    ProductCardModal.prototype.getSelectorAddCart = function () {
        return '#add-cartModal .btn-add-cart';
    };
    ProductCardModal.prototype.getSelectorSizeModel = function () {
        return '#add-cartModal .size-contain a';
    };
    ProductCardModal.prototype.getSelectorSelectSizeModel = function () {
        return 'select[name="size"]';
    };
    ProductCardModal.prototype.getSelectorSelectsFeatures = function () {
        return '#add-cartModal #container-select-features select';
    };
    ProductCardModal.prototype.getSelectorBodyModal = function () {
        return '#add-cartModal .modal-body';
    };
    ProductCardModal.prototype.getSelectorColorModel = function () {
        return '#add-cartModal .colors-models a';
    };
    ProductCardModal.prototype.getSelectorSelectColorModel = function () {
        return 'select[name="color"]';
    };
    ProductCardModal.prototype.getProductId = function () {
        return this.getElementInputQuantity().data('product_id');
    };
    ProductCardModal.prototype.getCartQuantity = function () {
        return parseInt(this.getElementInputQuantity().val());
    };
    ProductCardModal.prototype.getElementSelectsFeatures = function () {
        return $(this.getSelectorSelectsFeatures());
    };
    ProductCardModal.prototype.getRouteChooseProductFromFeature = function () {
        return $('#add-cartModal #container-select-features').data('route');
    };
    ProductCardModal.prototype.getProductParentId = function () {
        return $('#add-cartModal #container-select-features').data('product_parent_id');
    };
    ProductCardModal.prototype.getElementBodyModal = function () {
        return $(this.getSelectorBodyModal());
    };
    ProductCardModal.prototype.hideModal = function () {
        // @ts-ignore
        $('#add-cartModal').modal('hide');
    };
    ProductCardModal.prototype.replaceModalContent = function (data) {
        $('#add-cartModal').addClass('confirm');
        $('#add-cartModal .modal-content').html(data);
        this.removeModalClassOnClose('confirm');
    };
    ProductCardModal.prototype.removeModalClassOnClose = function ($class) {
        $('#add-cartModal').on('hidden.bs.modal', function () {
            $('#add-cartModal').removeClass($class);
        });
    };
    ProductCardModal.prototype.initEvents = function () {
        var _this = this;
        var cardModal = $('#add-cartModal');
        /* Quantité fleche up */
        $(this.getSelectorUpQuantity()).on('click', function (e) {
            e.preventDefault();
            _this.updateQuantity('+');
        });
        /* Quantité fleche down */
        $(this.getSelectorDownQuantity()).on('click', function (e) {
            e.preventDefault();
            _this.updateQuantity('-');
        });
        /* Clic sur l'ajour au panier dans le bloc product-item */
        $(this.getSelectorAddCart()).on('click', function (e) {
            _this.addToCart();
        });
        $(this.getSelectorSizeModel()).on('click', function (e) {
            e.preventDefault();
            cardModal.find(_this.getSelectorSelectSizeModel()).val($(e.target).data('size'));
            _this.getInfosFromFeatures();
        });
        /*Change select value color*/
        $(this.getSelectorColorModel()).on('click', function (e) {
            e.preventDefault();
            var new_val = $(e.target).attr('class');
            new_val = new_val.replace('active', '').replace('disabled', '').trim();
            cardModal.find(_this.getSelectorSelectColorModel()).val(new_val);
            _this.getInfosFromFeatures();
        });
    };
    ProductCardModal.prototype.initPluginsModal = function () {
        // @ts-ignore
        Kernel.factories.CustomSelectVariant($('#add-cartModal'));
        $('.product-form-select select').each(function () {
            // @ts-ignore
            Kernel.factories.CustomSelect($(this));
        });
    };
    ProductCardModal.prototype.updateQuantity = function ($operation) {
        var $el = this.getElementInputQuantity();
        var max = parseInt($el.attr('max'));
        var val = parseInt($el.val());
        if ($operation === "+") {
            val = val + 1;
        }
        else {
            if (val > 1) {
                val = val - 1;
            }
        }
        if (val <= max) {
            this.getElementInputQuantity().val(val);
            if (val === max) {
                // @ts-ignore
                Kernel.factories.Toaster($('html'), 'error', $el.data('max_error'));
            }
        }
    };
    ProductCardModal.prototype.addToCart = function () {
        var _this = this;
        HegydCore_1.default.sendRequest($('#add-cartModal').find('.btn-add-cart').attr('data-href'), 'POST', {
            product_id: this.getProductId(),
            quantity: this.getCartQuantity(),
            return_templates: ['cart-header']
        }, function (data) {
            if (data.open_store_locator) {
                var $element = $(_this.getSelectorAddCart());
                HegydCore_1.default.initRemoteModal('#modal-store', $element.attr('data-modal-href'), null, function (cbData) {
                    if (cbData.shop_name) {
                        refreshHeaderShopName_1.default(cbData.shop_name);
                    }
                    _this.addToCart();
                });
            }
            else {
                eCommerce_1.default(data);
                if (data.modal) {
                    _this.replaceModalContent(data.modal);
                }
                else {
                    _this.hideModal();
                    // @ts-ignore
                    Kernel.factories.Toaster($('html'), 'success', data.message);
                }
            }
        });
    };
    ProductCardModal.prototype.getInfosFromFeatures = function () {
        var _this = this;
        var features = {};
        this.getElementSelectsFeatures().each(function () {
            features[$(this).data('feature_id')] = $(this).val();
        });
        this.displayLoader();
        HegydCore_1.default.sendRequest(this.getRouteChooseProductFromFeature(), 'POST', {
            parent_id: this.getProductParentId(),
            features: features,
            from_modal: true
        }, function (data) {
            _this.hideLoader();
            _this.getElementBodyModal().empty().html(data.product_view_modal);
            _this.initEvents();
        }, function () {
            _this.hideLoader();
        });
    };
    ProductCardModal.prototype.displayLoader = function () {
        $('#product_loader').removeClass('d-none');
        $('#product_content').addClass('d-none');
    };
    ProductCardModal.prototype.hideLoader = function () {
        $('#product_loader').addClass('d-none');
        $('#product_content').removeClass('d-none');
    };
    return ProductCardModal;
}(BaseComponent_1.default));
exports.default = ProductCardModal;
;
